<template lang="pug">
  .full-screen-iframe(v-if='link')
    iframe(:src='link', width='100%', height='100%')
    .button
      .el-icon-close.item(@click='link = ""')
      a.el-icon-more-outline.item(:href='link', target='_blank')
</template>
<script>
export default {
  name: 'viframe',
  data() {
    return {
      link: '',
    }
  },
  mounted() {
    this.$vgo.on('OPEN_IFRAME', link => {
      this.link = link
    })
  },
}
</script>

<style lang="stylus">
.full-screen-iframe
  iframe
    background-color #fff
    z-index 998
    position fixed
    left 0
    top 0
  .button
    z-index 999
    position fixed
    left: 10px
    bottom: 20px
    display flex
    flex-direction column
    .item
      width: 31.2px
      height: 31.2px
      line-height: 31.2px
      margin-bottom: 5px
      text-align: center
      cursor: pointer
      background-color: rgba(255,73,73,.88)
      border-radius: 50%
      color #ddd
</style>
